import { browser } from '$app/environment';
import type { LayoutLoad } from './$types';
import { setAuthState, refreshSession } from '$lib/stores/authStore';
import { setupI18n, resetI18nInitialization } from '$lib/i18n';
import { supabase } from '$lib/supabase';

export const load: LayoutLoad = async ({ data }) => {
  console.log('レイアウトロード関数が実行されています');

  // サーバーから渡されたセッション情報
  const serverSession = data.session;
  console.log('サーバーから受け取ったセッション:', { 
    hasSession: !!serverSession,
    userId: serverSession?.user?.id,
    emailHash: serverSession?.user?.email ? serverSession.user.email.substring(0, 3) + '...' : 'なし'
  });

  if (browser) {
    // 強制的にi18n初期化をリセットして再初期化
    resetI18nInitialization();
    setupI18n();

    // ロケールを確認
    const currentLocale = localStorage.getItem('preferred-locale');
    console.log('現在のロケール設定:', currentLocale);

    // クライアントサイドでも認証状態を確認・更新
    try {
      const { data: { session } } = await supabase.auth.getSession();
      console.log('クライアントでセッションを確認:', { 
        hasSession: !!session, 
        userId: session?.user?.id,
        emailHash: session?.user?.email ? session.user.email.substring(0, 3) + '...' : 'なし'
      });
      
      // セッション情報の比較
      const sessionMatch = serverSession?.user?.id === session?.user?.id;
      console.log('サーバーとクライアントのセッション一致:', sessionMatch);
      
      // 最新のセッション情報をストアに設定
      setAuthState(session?.user ?? serverSession?.user ?? null, false);
      
      // 認証状態変更のリスナーを設定
      const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
        console.log('認証状態変更:', event, { hasUser: !!session?.user });
        if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
          setAuthState(session?.user ?? null, false);
        } else if (event === 'SIGNED_OUT') {
          setAuthState(null, false);
        }
      });
      
      return {
        session: session ?? serverSession,
        cleanup: () => {
          subscription?.unsubscribe();
        }
      };
    } catch (error) {
      console.error('認証状態確認エラー:', error);
      setAuthState(serverSession?.user ?? null, false);
    }
  }

  return {
    session: serverSession
  };
};